
window.addEventListener('load', function() {
	  const menuItems = document.querySelectorAll('.menu-item-has-children');

	  menuItems.forEach(menuItem => {
		menuItem.addEventListener('mouseover', () => {
		  menuItem.classList.add('show');
		});

		menuItem.addEventListener('mouseout', () => {
		  setTimeout(() => {
			menuItem.classList.remove('show');
		  }, 50);
		});
	  });
});

$(document).ready(function(){
	$('.menu-button').on('click', function(){
		$(this).toggleClass('opened');
		$('#mobile-main-nav').toggleClass('opened');
	});

	$('.menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
	});

	$('.menu-item-has-children').on('click', function(e){
		$(this).toggleClass('opened');
	});


});